import React, { Component } from "react";
import moment from "moment";
import helperFunctions from "../../utils/functions";
import { Spin, message } from "antd";
import Bridge from "../../utils/Bridge";
import { FaEye } from "react-icons/fa";

export default class AlsFrsr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      loading: false,
      eals_id: localStorage.getItem("ap_eals_id"),
    };
  }
  componentDidMount() {
    this.get_eals_frs_list();
  }
  get_eals_frs_list = () => {
    this.setState({ loading: true });
    let params = "?eals_id=" + this.state.eals_id;
    Bridge.participants.ecas_study.get_ecas_study_alsfrsr_score(params)
      .then((res) => {        
        if (res.status == "1") {
          let records = [];
          for(let item of res.data.digital_forms){
            item.type = "Digital";
            console.log('item',item);            
            let date = item.date ? moment(item.date.split(" ")[0]).format("MM/DD/YYYY") + " " + item.date.split(" ")[1] + " " + item.date.split(" ")[2] : "---";
            item.form_submission_date = date ? date : "---";
            console.log('item.form_submission_date',item.form_submission_date);
            
            records.push(item);
          }
          for(let item of res.data.physical_forms){
            item.type = "In-Clinic";
            item.form_submission_date = item.submitted_date ? moment(item.submitted_date).format("MM/DD/YYYY HH:mm ss A") : "---";
            records.push(item);
          }
          let tempArray=records.sort((a, b) => {
            // If either date is missing, push it to the end
            if(a.form_submission_date === "---") return 1;
            if(b.form_submission_date === "---") return -1;
            // Sort in descending order (latest first)
            return moment(b.form_submission_date, "MM/DD/YYYY HH:mm ss A") - moment(a.form_submission_date, "MM/DD/YYYY HH:mm ss A");
          });


          this.setState({
            records: tempArray,
            loading: false,
          });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  view_file=(item,_single,file)=>{
    let params={
      physical_ecas_study_alsfrsr_form_id:item.physical_ecas_study_alsfrsr_form_id,
      is_single:_single,
      file: file
    }
    Bridge.personal_data_viewer.ecas_study.get_physical_ecas_study_alsfrsr_form_url(params).then((res)=>{
      if(res.status==1){
        window.open(res.data,'_blank')
        return;
      }else{
        message.warning(res.message)
      }
    })
  }
  isJSON=(str) =>{
    try {
      const parsed = JSON.parse(str);
      return Array.isArray(parsed); // true if it's a JSON array
    } catch (e) {
      return false; // Not valid JSON
    }
  }
  render() {
    return (
      <div className="als_frs_sessions">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-0">
            <h5 className="mb-0">ALSFRS-R Form List</h5>
              <a
                href="/upload-ecas-alsfrs-r-form"
                style={{ padding:"5px 20px",float:"right",position:"relative",zIndex:10 }}
                className="red_big_button d-flex align-items-center float-right"
              >
                <box-icon 
                  name="plus"
                  color="#fff"
                  size={'27px'}
                  style={{position:'relative',top:0,left:-3 }}
                ></box-icon> Upload ALSFRS-R Form
              </a>
              <br/>
              <br/>
              <br/>
              <Spin spinning={this.state.loading}>
                {this.state.records.length > 0 && (
                  <div className="als_frs_sessions_table">
                    <table>
                      <tr>
                          <th>Date</th>
                          <th>Speech</th>
                          <th>Salivation</th>
                          <th>Swallowing</th>
                          <th>Handwriting</th>
                          <th>Cutting Food</th>
                          <th>Dressing and Hygiene</th>
                          <th>Turning in bed</th>
                          <th>Walking</th>
                          <th>Climbing stairs</th>
                          <th>Dyspnea</th>
                          <th>Orthopnea</th>
                          <th>Respiratory insufficiency</th>
                          <th>Type</th>
                          <th>Total</th>
                          <th>View</th>
                      </tr>
                      {this.state.records &&
                          this.state.records.map((item, index) => {
                          let speechColor = helperFunctions.getColor(item.speech);
                          let salavationColor = helperFunctions.getColor(
                              item.salivation
                          );
                          let swallowingColor = helperFunctions.getColor(
                              item.swallowing
                          );
                          let handwritingColor = helperFunctions.getColor(
                              item.handwriting
                          );
                          let cutting_food_value = "";
                          let food_type = "";
                          let cuttingFoodColor = helperFunctions.getColor(
                              item.cutting_food_a
                          );
                          if (item.cutting_food_a) {
                            food_type = "(A)";
                              cutting_food_value = item.cutting_food_a;
                              cuttingFoodColor = helperFunctions.getColor(
                              item.cutting_food_a
                              );
                          } else if (item.cutting_food_b) {
                              cutting_food_value = item.cutting_food_b;
                              cuttingFoodColor = helperFunctions.getColor(
                              item.cutting_food_b
                              );
                              food_type = "(B)";
                          }

                          let dressingColor = helperFunctions.getColor(
                              item.dressing_and_hygiene
                          );
                          let turingColor = helperFunctions.getColor(
                              item.turning_in_bed
                          );
                          let walkingColor = helperFunctions.getColor(item.walking);
                          let climbingColor = helperFunctions.getColor(
                              item.climbing_stairs
                          );
                          let dyspneaColor = helperFunctions.getColor(item.dyspnea);
                          let orthopneaColor = helperFunctions.getColor(
                              item.orthopnea
                          );
                          let respiratoryColor = helperFunctions.getColor(
                              item.respiratory_insufficiency
                          );
                          let date = item.form_submission_date ? item.form_submission_date : "---";
                          let _single=false
                          let all_files=[]
                          let form_links=this.isJSON(item.form_link)
                          if(form_links==true){
                            _single=false
                            all_files=JSON.parse(item.form_link)
                          }else{
                            _single=true
                            form_links=[item.form_link];
                          }
                          return (
                              <tr key={index}>
                              <td style={{width:110}}>
                                  {date}
                              </td>
                              <td class={speechColor}>{item.speech ? item.speech : "---"}</td>
                              <td class={salavationColor}>{item.salivation}</td>
                              <td class={swallowingColor}>{item.swallowing ? item.swallowing : "---"}</td>
                              <td class={handwritingColor}>{item.handwriting ? item.handwriting : "---"}</td>
                              <td class={cuttingFoodColor}>{cutting_food_value ? cutting_food_value + " " + food_type : "---"}</td>
                              <td class={dressingColor}>
                                  {item.dressing_and_hygiene ? item.dressing_and_hygiene : "---"}
                              </td>
                              <td class={turingColor}>{item.turning_in_bed ? item.turning_in_bed : "---"}</td>
                              <td class={walkingColor}>{item.walking ? item.walking : "---"}</td>
                              <td class={climbingColor}>{item.climbing_stairs ? item.climbing_stairs : "---"}</td>
                              <td className={dyspneaColor}>{item.dyspnea ? item.dyspnea : "---"}</td>
                              <td className={orthopneaColor}>{item.orthopnea ? item.orthopnea : "---"}</td>
                              <td className={respiratoryColor}>
                                  {item.respiratory_insufficiency ? item.respiratory_insufficiency : "---"}
                              </td>
                              <td style={{width:40}}>{item.type}</td>
                              <td>{item.ALS_total ? item.ALS_total : "---"}</td>
                              <td>
                                {item.type=='Digital' && (
                                  <span>---</span>
                                )}
                                {item.type=='In-Clinic' && (
                                  <>
                                    {item.form_link ? (
                                      <>
                                      {_single==true ? (
                                        <button
                                          className="btn btn-primary mb-2"
                                          onClick={()=>this.view_file(item,_single,item.form_link)}
                                          style={{
                                            background: "#d06338",
                                            border: "1px solid #d06338",
                                          }}
                                        >
                                          <FaEye
                                            style={{ position: "relative", top: -2 }}
                                          />{" "}
                                          View
                                        </button>
                                      ):(
                                        <>
                                        {all_files.map((single_file,index)=>{
                                          return (
                                            <button
                                              key={index}
                                              className="btn btn-primary mb-2"
                                              onClick={()=>this.view_file(item,_single,single_file)}
                                              style={{
                                                background: "#d06338",
                                                border: "1px solidrgb(57, 52, 50)"
                                              }}
                                            >
                                              <FaEye
                                                style={{ position: "relative", top: -2 }}
                                              />{" "}
                                              View File {all_files.length > 1 ? (index+1) : ""}
                                            </button>   
                                          )
                                        })}
                                        </>
                                      )}
                                      </>
                                    ): "---"}
                                  </>
                                )}
                              </td>
                              </tr>
                          );
                          })}
                    </table>
                  </div>
                )}
                {this.state.records.length == 0 && (
                    <div className="col-lg-12">
                    <div
                        style={{
                        fontSize: 20,
                        textAlign: "center",
                        padding: 20,
                        }}
                    >
                        Not available..
                    </div>
                    </div>
                )}
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
